
















import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class ListDividedItem extends Vue {
  @Prop({ required: true }) public label!: string;
  @Prop({ default: null }) public labelDescription!: string | null;
  @Prop({ default: "" }) public itemLabelClass!: string;
  @Prop({ default: "" }) public itemLabelDescriptionClass!: string;
  @Prop({ default: "" }) public itemValueClass!: string;
}
